import { HttpClient } from '@angular/common/http';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ErpIntegrationStatusService {

  baseUrl = Constants.CORE_API_BASE_URL;
  constructor(private http: HttpClient) { }

  getGroups(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Common/GetGroup', data);
  }

  getPlantData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Common/GetDepartments', data);
  }

  getLineList(data: any): Observable<any> {
    return this.http.get<any[]>(this.baseUrl + 'Dashboard/GetLineList', data);
  }

  getUnit(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Dashboard/GetUnitListByLine', data);
  }

  getJbBatchHistory(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'ERPIntegrationStatus/GetJbBatchHistory', data);
  }

  filterData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'ERPIntegrationStatus/ERPIntegrationStatus', data);
  }

  saveSapProductionOutput(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/SaveSapProductionOutput', data);
  }

  saveSapMaterialConsumption(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/SaveSapMaterialConsumption', data);
  }

}
